<template>
  <div class="giftChatBox">
<!--    姓名-->
    <div class="name">"{{ name }}"</div>
<!--    做什么-->
    <div class="action">送出一个鲜花</div>
<!--    礼物图像-->
    <div class="gift">
      <img :src="giftImg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "giftChat",
  props:{
    giftImg:{
      type: String,
      default: require("../../../../assets/live/flowerS.png")
    },
    name:{
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.giftChatBox{
  position: relative;
  margin: auto;
  margin-top: 40px;
  width: 100%;
  font-size: 37px;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name{
  color: #0054ff;
  max-width: 400px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.action{
  color: #b2b2b2;
  margin-right: 4px;
}
.gift{
  width: 50px;
  height: 50px;
}
</style>